import React from "react";
import styled from "styled-components";
import fadleElzikerData from "./FadleElzikrData";

const Container = styled.div`
  padding: 20px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
`;

const FadlElzikerWrapper = styled.div`
  border: 1px solid rgba(var(--sec-color-rgba), 0.8);
  border-radius: 10px;
  padding: 10px;
`;

const Title = styled.h2`
  font-size: 15px;
  border-bottom: 1px solid var(--sec-color);
  width: 50%;
  padding-right: 10px;
  padding-bottom: 5px;
  margin-right: -10px;
  margin-bottom: 10px;
`;
const ParaGraph = styled.p``;

function FadlElziker() {
  const zikrList = fadleElzikerData.zikrList;
  const randomNum = Math.ceil(Math.random() * zikrList.length);
  return (
    <Container>
      <FadlElzikerWrapper>
        <Title>{fadleElzikerData.title}</Title>
        <ParaGraph>{zikrList[randomNum]}</ParaGraph>
      </FadlElzikerWrapper>
    </Container>
  );
}

export default React.memo(FadlElziker);
